import { Injectable } from '@angular/core';
import { EntityState, EntityStore } from '@datorama/akita';
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { IAttachment } from '@common/interfaces/attachment'
import { ID } from '@common/interfaces/id';
import { Topics } from '@common/interfaces/topics';

export interface AttachmentState extends EntityState<IAttachment, ID> {}

@Injectable({ providedIn: 'root' })
@PersistedStoreConfig({ name: Topics.ATTACHMENT , realtimeEntity: 'IssueAttachment'})
export class AttachmentStore extends EntityStore<AttachmentState> {
  constructor() {
    super([]);
  }
}
